export default __webpack_public_path__ + "static/media/team-bg.f597f290.png";